var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Dependencies } from "~/core/decorator";
import { PersonalService } from "~/services/business-service/personal.service";
var collectionManageModule = namespace("collection-manage");
var AddressRemarkModify = /** @class */ (function (_super) {
    __extends(AddressRemarkModify, _super);
    function AddressRemarkModify() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false
        };
        _this.model = {
            id: _this.caseId,
            remark: '',
            type: 1,
            caseType: '',
            caseId: ''
        };
        _this.rules = {
            remark: [{ required: true, message: "请输入备注信息", trigger: "blur" }]
        };
        _this.phoneType = [];
        _this.relations = [];
        return _this;
    }
    AddressRemarkModify.prototype.success = function () {
    };
    AddressRemarkModify.prototype.close = function () {
        this.reset();
    };
    AddressRemarkModify.prototype.mounted = function () {
    };
    AddressRemarkModify.prototype.updatedModel = function (currentRelation) {
        if (currentRelation) {
            this.model.id = currentRelation.id;
            this.model.remark = currentRelation.remark;
        }
    };
    /**
     * 新增备注
     */
    AddressRemarkModify.prototype.commit = function () {
        var _this = this;
        var form = this.$refs["form"];
        form.validate(function (valid) {
            if (!valid)
                return;
            _this.model.caseType = _this.otherData.caseType;
            _this.model.caseId = _this.caseId;
            // 加载等待
            _this.loading.state = true;
            _this.personalService.modifyRemark(_this.model, _this.loading).subscribe(function (data) {
                _this.success();
                _this.close();
            }, function (error) {
                _this.$message.error(error.msg);
            });
        });
    };
    AddressRemarkModify.prototype.reset = function () {
        var form = this.$refs["form"];
        form.resetFields();
    };
    __decorate([
        Dependencies(PersonalService)
    ], AddressRemarkModify.prototype, "personalService", void 0);
    __decorate([
        collectionManageModule.State
    ], AddressRemarkModify.prototype, "otherData", void 0);
    __decorate([
        Prop()
    ], AddressRemarkModify.prototype, "caseId", void 0);
    __decorate([
        Emit("success")
    ], AddressRemarkModify.prototype, "success", null);
    __decorate([
        Emit("close")
    ], AddressRemarkModify.prototype, "close", null);
    AddressRemarkModify = __decorate([
        Component({
            components: {}
        })
    ], AddressRemarkModify);
    return AddressRemarkModify;
}(Vue));
export default AddressRemarkModify;
